import { render, staticRenderFns } from "./CoinsContainer.vue?vue&type=template&id=a9df0c1e&scoped=true&"
import script from "./CoinsContainer.vue?vue&type=script&lang=ts&"
export * from "./CoinsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./CoinsContainer.scss?vue&type=style&index=0&id=a9df0c1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9df0c1e",
  null
  
)

export default component.exports